<script setup lang="ts">
import ReportBody from '@/components/Report/Body/ReportBody.vue'
import ReportHeader from '@/components/Report/Header/ReportHeader.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { useReportStore } from '@/store/report'
import { storeToRefs } from 'pinia'
import { useI18n } from '@/composable/useI18n'
import IcEmptyBox from '@/components/Icons/IcEmptyBox.vue'

const { t } = useI18n()
const { hasReport } = storeToRefs(useReportStore())
</script>

<template>
  <DefaultLayout>
    <div id="report-view-container" class="min-w-0 w-full max-w-full">
      <ReportHeader />
      <ReportBody v-if="hasReport" />

      <div v-else class="flex flex-col items-center px-6 pb-12 pt-8 text-center lg:px-8">
        <IcEmptyBox class="h-90 pb-12" />
        <p class="font-satoshi text-lg font-bold text-black">
          {{ t('report.empty.no_data') }}
        </p>
        <p class="mt-2 max-w-md text-sm font-medium text-gray-500">
          {{ t('report.empty.hint') }}
        </p>
      </div>
    </div>
  </DefaultLayout>
</template>
